import { LayoutElements, LayoutInputParams } from '@mkp/layout/models';
import { User } from '@mkp/user/models';
import { ElementBuilder } from './layout-element-config-builder';
import {
  ANY_ORDER_SUMMARY,
  BOOST_SUCCESS,
  BOOST_VACANCY,
  BOOST_VACANCY_SUMMARY,
  BO_CLAIM_COMPANY,
  CLAIM_COMPANY,
  CLAIM_MANAGEMENT_DETAILS_WITH_ID,
  CREATE_INVITE,
  CREATE_VACANCY,
  DESIGN_SYSTEM,
  EDIT_VACANCY_PATTERN,
  EXTEND,
  INCOMPLETE_ONBOARDING,
  INVALID_INVITE,
  LANDING_PAGE,
  LOGIN_PAGE,
  MY_USER_PROFILE,
  ONBOARDING,
  PAY_PER_INVITE,
  PUBLISH_VACANCY_PATTERN,
  PURCHASE_CREDITS,
  PURCHASE_CREDITS_COMPARISON,
  REDEEM_INVITE,
  SELECT_WORKSPACE,
  VACANCY_GROUP_FORM,
  VERIFY_IDENTITY,
  removeQueryParams,
  urlMatchesAnyPage,
} from './layout-pages.helpers';

export const areLayoutElementsDifferent = (
  prev: LayoutElements,
  curr: LayoutElements,
  isMobile: boolean
) => {
  return (
    isMobile ||
    prev.isNavigationCollapsed === undefined ||
    prev.hasNavigation !== curr.hasNavigation ||
    prev.hasBorders !== curr.hasBorders ||
    prev.hasFooter !== curr.hasFooter ||
    prev.normalDocumentFlow !== curr.normalDocumentFlow ||
    prev.hasTopHeader !== curr.hasTopHeader
  );
};

export const getPageLayoutElements = ({
  url,
  isMobile,
  isTablet,
  user,
}: LayoutInputParams): LayoutElements => {
  const sanitizedUrl = removeQueryParams(url);
  if (urlMatchesAnyPage(PAGES_WITHOUT_NAVIGATION, sanitizedUrl, [CREATE_INVITE])) {
    return new ElementBuilder().withTopHeader().withBorders(!isMobile).withFooter().build();
  }
  if (urlMatchesAnyPage(PUBLIC_PAGES, sanitizedUrl)) {
    return new ElementBuilder().withTopHeader().withFooter().withNormalDocumentFlow().build();
  }

  if (urlMatchesAnyPage(REG_FLOW, sanitizedUrl, [BO_CLAIM_COMPANY])) {
    return new ElementBuilder().withTopHeader().build();
  }
  return createDefaultLayoutElements(user, isMobile, isTablet);
};

function createDefaultLayoutElements(
  user: User | null | undefined,
  isMobile: boolean,
  isTablet: boolean
): LayoutElements {
  return new ElementBuilder()
    .withNavigation(!!user)
    .withNavigationCollapsed(isMobile || isTablet)
    .withBorders(!!user && !isMobile)
    .withFooter()
    .withTopHeader()
    .build();
}

const PUBLIC_PAGES = [LANDING_PAGE];

const PAGES_WITHOUT_NAVIGATION = [
  CREATE_VACANCY,
  PUBLISH_VACANCY_PATTERN,
  VACANCY_GROUP_FORM,
  EDIT_VACANCY_PATTERN,
  ANY_ORDER_SUMMARY,
  PURCHASE_CREDITS,
  EXTEND,
  PURCHASE_CREDITS_COMPARISON,
  SELECT_WORKSPACE,
  MY_USER_PROFILE,
  CLAIM_MANAGEMENT_DETAILS_WITH_ID,
  BOOST_VACANCY,
  BOOST_VACANCY_SUMMARY,
  BOOST_SUCCESS,
  DESIGN_SYSTEM,
  PAY_PER_INVITE,
];

const REG_FLOW = [
  CLAIM_COMPANY,
  LOGIN_PAGE,
  ONBOARDING,
  VERIFY_IDENTITY,
  REDEEM_INVITE,
  INVALID_INVITE,
  INCOMPLETE_ONBOARDING,
];
